import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Only 'en' is bundled; all other languages are loaded on demand via lazyResources.
const en = require('./translations/en.json');

const NS = 'translation';

// Each language becomes its own async chunk, loaded only when detected or selected.
const lazyResources: Record<string, () => Promise<any>> = {
  hi: () => import('./translations/hi.json'),
  ar: () => import('./translations/ar.json'),
  ba: () => import('./translations/ba.json'),
  fr: () => import('./translations/fr.json'),
  pt: () => import('./translations/pt.json'),
  en_MY: () => import('./translations/en-my.json'),
  en_SC: () => import('./translations/en-sc.json'),
  pl: () => import('./translations/pl.json'),
  id: () => import('./translations/id.json'),
  vi: () => import('./translations/vi.json'),
  ru: () => import('./translations/ru.json'),
  th: () => import('./translations/th.json'),
  en_FR: () => import('./translations/en-fr.json'),
  ar_YP: () => import('./translations/ar-yp.json'),
  en_aramex: () => import('./translations/en-aramex.json'),
};

const loadLanguage = async (lng?: string) => {
  if (!lng || !lazyResources[lng] || i18n.hasResourceBundle(lng, NS)) {
    return;
  }
  try {
    const mod: any = await lazyResources[lng]();
    const json = mod && mod.default ? mod.default : mod;
    i18n.addResourceBundle(lng, NS, json[NS] || json, true, true);
    await i18n.changeLanguage(lng);
  } catch (e) {
    console.error(`Failed to load translations for language: ${lng}`, e);
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ns: [NS],
    fallbackLng: 'en',
    resources: { en }, // en.json is already shaped as { translation: {...} }
    // resources only ships the fallback; others are added at runtime via loadLanguage.
    partialBundledLanguages: true,
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    keySeparator: false,
    nsSeparator: false,
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'lng',
    },
  })
  .finally(() => {
    // After detection, pull in the active language if it isn't the bundled fallback.
    loadLanguage(i18n.language);
  });

i18n.on('languageChanged', (lng) => {
  loadLanguage(lng);
});

export default i18n;
